export default [
  {
    path: '/app/webforms',
    name: 'WebForms',
    component: () => import('@/views/Admin/WebForms/Index.vue'),
    resource: 'ADMIN_WEBFORMS',
    action: 'read',
  },
  {
    path: '/app/webforms/view/:id',
    name: 'WebForms',
    component: () => import('@/views/Admin/WebForms/View.vue'),
    meta: {
      pageTitle: 'Başvuru Formları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/webforms',
          active: false,
        },
        {
          text: 'Görüntüle',
          active: true,
        },
      ],
      resource: 'ADMIN_WEBFORMS_LIST',
      action: 'read',
    },
  },
]
